<template>
  <div>
    <loading :loading="loading" />
    <form v-if="!loading" @submit.prevent="() => {}">
      <br />
      <md-card class="md-layout-item">
        <md-card-header>
          <div class="md-title">Notificação</div>
        </md-card-header>
        <md-card-content>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-100">
              <md-field :class="getValidationClass('identificacao')">
                <label for="identificacao">Identificação</label>
                <md-input
                  id="identificacao"
                  v-model="form.identificacao"
                  name="identificacao"
                />
                <span v-if="!$v.form.identificacao.required" class="md-error"
                  >Identificação é obrigatório</span
                >
              </md-field>
            </div>

            <div class="md-layout-item md-size-100">
              <md-field :class="getValidationClass('titulo')">
                <label for="titulo">Titulo</label>
                <md-input id="titulo" v-model="form.titulo" name="titulo" />
                <span v-if="!$v.form.titulo.required" class="md-error"
                  >Título é obrigatório</span
                >
              </md-field>
            </div>

            <div class="md-layout-item md-size-100">
              <md-field :class="getValidationClass('mensagem')">
                <label for="mensagem">
                  Mensagem ($SENSOR irá ser substituído pelo valor associado)
                </label>
                <md-textarea
                  id="mensagem"
                  v-model="form.mensagem"
                  name="mensagem"
                />
                <span v-if="!$v.form.mensagem.required" class="md-error"
                  >Mensagem é obrigatório</span
                >
              </md-field>
            </div>
            <div class="md-layout-item md-size-45">
              <sensor-autocomplete
                id="sensores"
                v-model="form.sensorId"
                name="sensores"
                :local-id="localId"
                :label="'Sensor associado'"
              />
            </div>

            <div class="md-layout-item md-size-20">
              <md-field>
                <label for="nivelNotificacao">Nível da Notificação</label>
                <md-select
                  id="nivelNotificacao"
                  v-model="form.nivelNotificacao"
                  name="nivelNotificacao"
                >
                  <md-option :value="0"> Informação </md-option>
                  <md-option :value="1"> Alerta </md-option>
                  <md-option :value="2"> Crítico </md-option>
                </md-select>
              </md-field>
            </div>

            <div class="md-layout-item md-size-100">
              <label for="titulo"
                >Dias da semana para executar a notificação</label
              >
              <br />
              <br />
              <md-chip
                v-for="(dia, index) in dias"
                :key="dia"
                :class="{
                  'md-primary': validaSeDiaExecutaAcao(index),
                  'md-grey': !validaSeDiaExecutaAcao(index),
                }"
                md-clickable
                @click="() => alternaDia(index)"
              >
                {{ dia }}
              </md-chip>
            </div>

            <div class="md-layout-item md-size-40 mt-2">
              <md-field
                :class="getValidationClass('tempoEsperaEntreNotificacoes')"
              >
                <label for="tempoEsperaEntreNotificacoes"
                  >Tempo entre os envios</label
                >
                <md-input
                  id="tempoEsperaEntreNotificacoes"
                  v-model="form.tempoEsperaEntreNotificacoes"
                  v-mask="'##:##'"
                  name="tempoEntreNotificacoes"
                />
                <span
                  v-if="!$v.form.tempoEsperaEntreNotificacoes.dayTime"
                  class="md-error"
                  >Data inválida</span
                >
              </md-field>
            </div>
            <div class="md-layout md-layout-item md-alignment-center-left">
              <md-button
                class="md-primary md-raised"
                @click.stop="() => toggleTab()"
              >
                Ações Automáticas
              </md-button>
            </div>

            <div class="md-layout-item md-size-100">
              <md-switch
                v-model="notificacaoRecorrente"
                @change="
                  (e) => (e === false ? (form.tempoDeVerificacao = null) : null)
                "
              >
                Notificação Recorrente
              </md-switch>
            </div>

            <div v-if="notificacaoRecorrente" class="md-layout-item md-size-40">
              <md-field :class="getValidationClass('tempoDeVerificacao')">
                <label for="tempoDeVerificacao">Tempo de verificação</label>
                <md-input
                  id="tempoDeVerificacao"
                  v-model="form.tempoDeVerificacao"
                  v-mask="'##:##'"
                  name="tempoDeVerificacao"
                />
                <span
                  v-if="!$v.form.tempoDeVerificacao.dayTime"
                  class="md-error"
                  >Data inválida</span
                >
              </md-field>
            </div>

            <div class="md-layout-item md-size-100">
              <md-switch v-model="horarioExecutarNotificacoes">
                Horário para executar a notificação
              </md-switch>
            </div>

            <div
              v-if="horarioExecutarNotificacoes"
              class="md-layout-item md-size-100 mt-4"
            >
              <div class="md-layout">
                <div class="md-layout-item md-size-45">
                  <md-field :class="getValidationClass('inicio')">
                    <label for="horarioInicio">Início</label>
                    <md-input
                      id="horarioInicio"
                      v-model="form.inicio"
                      v-mask="'##:##'"
                      name="horarioInicio"
                    />
                    <span v-if="!$v.form.inicio.dayTime" class="md-error"
                      >Horário inválido</span
                    >
                  </md-field>
                </div>
                <div
                  class="md-layout-item md-size-10"
                  style="margin: auto; width: 50%"
                >
                  <md-icon class="md-size-2x" style="padding-left: 50%">
                    arrow_right_alt
                  </md-icon>
                </div>
                <div class="md-layout-item md-size-45">
                  <md-field :class="getValidationClass('fim')">
                    <label for="fim">Fim</label>
                    <md-input
                      v-model="form.fim"
                      v-mask="'##:##'"
                      name="horariofim"
                    />
                    <span v-if="!$v.form.fim.dayTime" class="md-error"
                      >Horário inválido</span
                    >
                  </md-field>
                </div>
              </div>
            </div>
          </div>
          <md-divider />
          <br />
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-30">
              <md-autocomplete
                v-model="cargoSelected"
                :md-options="cargoSearch"
              >
                <label>Cargos</label>
              </md-autocomplete>
            </div>
            <div class="md-layout-item">
              <md-button
                class="md-button md-primary md-raised"
                @click="adicionaCargo"
              >
                Adicionar
              </md-button>
            </div>
          </div>

          <md-chip
            v-for="cargo in form.notificacaoCargos"
            :key="cargo.id"
            class="md-primary"
            md-deletable
            @md-delete="() => removeCargo(cargo.id)"
          >
            {{ cargo.titulo }}
          </md-chip>

          <md-divider class="mt-2" />
          <div class="md-layout">
            <div class="md-layout-item md-size-80">
              <div class="md-subheading mt-3">Condições</div>
            </div>
            <div class="md-layout-item md-size-20" style="text-align: right">
              <md-button class="md-primary" @click="adicionaExpressao">
                Adicionar condição
              </md-button>
            </div>
          </div>
          <md-divider class="mb-4" />

          <md-dialog-confirm
            :md-active.sync="dialogRemoverExpressao"
            md-title="Deseja remover essa expressão?"
            md-confirm-text="Sim"
            md-cancel-text="Cancelar"
            @md-cancel="onCancelarRemoverExpressao"
            @md-confirm="onExcluirExpressao"
          />

          <div
            v-for="(expressao, i) in form.expressoes"
            :key="expressao._clientId"
          >
            <p v-if="i !== 0" class="and">AND</p>
            <div style="text-align: right">
              <md-button
                class="md-accent"
                @click="() => pedirRemoverExpressao(i)"
              >
                Remover
              </md-button>
            </div>
            <expressao
              :local-id="localId"
              :expressao="expressao"
              @change="(e) => atualizarExpressaoIndex(e, i)"
            />
            <md-divider />
          </div>

          <div style="text-align: right">
            <md-button class="md-primary" @click="() => $router.back()">
              voltar
            </md-button>
            <md-button class="md-primary md-raised" @click="salvar">
              Salvar
            </md-button>
          </div>
        </md-card-content>
      </md-card>
    </form>
    <slider-right id="slideLeft" ref="slider">
      <notificacao-acoes
        v-if="!loading"
        :local-id="localId"
        :notificacao-acaos-id="
          form.notificacaoAcaos.map((e) => e.botaoAcaoEquipamentoId)
        "
        @modificaNotificacaoAcoes="setBotoesDeAcionamento"
      />
    </slider-right>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import SensorAutocomplete from '@/components/autocomplete/SensorAutocomplete.vue'
import Loading from '@/components/Loading.vue'
import Expressao from '@/components/notificacao/Expressao'
import NotificacaoAcoes from '@/components/notificacao/NotificacaoAcoes'
import SliderRight from '@/components/SliderLeft'
import { getMs, parseDate } from '@/utils/transform'
import { validaData } from '@/utils/validations/date'

import http from '../../utils/http'

export default {
  name: 'NotificacaoInput',
  components: {
    SensorAutocomplete,
    Loading,
    Expressao,
    NotificacaoAcoes,
    SliderRight,
  },
  mixins: [validationMixin],
  data() {
    return {
      localId: null,
      notificacaoId: null,
      dialogRemoverExpressao: false,
      indexExpressaoRemover: null,
      nextExpressaoClientId: 1,
      form: {
        identificacao: null,
        mensagem: null,
        titulo: null,
        localId: null,
        expressoes: [],
        diasParaExecutarNotificacao: [...Array(7).keys()],
        notificacaoCargos: [],
        inicio: null,
        fim: null,
        tempoDeVerificacao: null,
        tempoEsperaEntreNotificacoes: null,
        notificacaoAcaos: [],
        nivelNotificacao: 0,
        sensorId: null,
      },
      horarioExecutarNotificacoes: false,
      notificacaoRecorrente: false,
      loading: true,
      local: null,
      dias: [
        'Domingo',
        'Segunda',
        'Terça',
        'Quarta',
        'Quinta',
        'Sexta',
        'Sábado',
      ],
      cargosCidade: [],
      cargoSearch: [],
      cargoSelected: '',
      botoesDeAcionamento: [],
    }
  },
  validations() {
    const rules = {
      form: {
        identificacao: { required },
        mensagem: { required },
        titulo: { required },
        tempoEsperaEntreNotificacoes: { dayTime: validaData },
      },
    }

    const dayTime = (value) => {
      if (this.horarioExecutarNotificacoes) {
        return validaData(value)
      }

      return true
    }

    if (this.horarioExecutarNotificacoes) {
      rules.form.inicio = { dayTime }
      rules.form.fim = { dayTime }
    }

    if (this.notificacaoRecorrente) {
      rules.form.tempoDeVerificacao = {
        dayTime: (value) => {
          if (this.notificacaoRecorrente) {
            return validaData(value)
          }

          return true
        },
      }
    }

    return rules
  },
  computed: {
    msInicio: () => {
      return getMs(...parseDate(this.form.inicio))
    },
    msFim: () => {
      return getMs(...parseDate(this.form.fim))
    },
  },
  async beforeMount() {
    this.localId = this.$route.params.localId
    this.notificacaoId = this.$route.params.notificacaoId

    await this.getNotificationData()
  },
  methods: {
    async getNotificationData() {
      this.loading = true

      this.cargosCidade = (await http.get(`local/${this.localId}/cargo`)).cargos

      this.cargoSearch = this.cargosCidade.map((e) => e.titulo)

      if (this.notificacaoId) {
        this.form = {
          ...this.form,
          ...(await http.get(`notificacao/${this.notificacaoId}`)).notificacao,
        }

        if (this.form.horarioExecutarNotificacao) {
          this.form.inicio = this.form.horarioExecutarNotificacao.inicio
          this.form.fim = this.form.horarioExecutarNotificacao.fim
        }

        this.horarioExecutarNotificacoes = !!(this.form.inicio && this.form.fim)

        this.notificacaoRecorrente = !!this.form.tempoDeVerificacao

        this.form.notificacaoCargos = this.form.notificacaoCargos.map(
          (e) => e.cargo
        )

        this.botoesDeAcionamento = this.form.notificacaoAcaos.map(
          (e) => e.botaoAcaoEquipamento
        )

        this.nextExpressaoClientId = 1
        this.form.expressoes = (this.form.expressoes || []).map(
          (expressao) => ({
            ...expressao,
            _clientId: this.novoClientId(),
          })
        )
      }

      this.loading = false
    },
    toggleTab() {
      this.$refs.slider.toogleTab()
    },
    setBotoesDeAcionamento(notificacaoAcoes) {
      this.botoesDeAcionamento = notificacaoAcoes
    },
    removeCargo(cargoId) {
      this.form.notificacaoCargos = this.form.notificacaoCargos.filter(
        (e) => e.id !== cargoId
      )
    },
    adicionaCargo() {
      const cargo = this.cargosCidade.find(
        (e) => e.titulo === this.cargoSelected
      )

      if (cargo == null) {
        return
      }

      if (this.form.notificacaoCargos.some((e) => e.id === cargo.id)) {
        return
      }

      this.cargoSelected = ''
      this.form.notificacaoCargos.push(cargo)
    },
    atualizarExpressaoIndex(expressao, index) {
      Object.assign(this.form.expressoes[index], expressao)
    },
    expressoesParaSalvar() {
      return this.form.expressoes.map(
        ({ _clientId, ...expressao }) => expressao
      )
    },
    novoClientId() {
      return `expr-${this.nextExpressaoClientId++}`
    },
    pedirRemoverExpressao(index) {
      this.indexExpressaoRemover = index
      this.dialogRemoverExpressao = true
    },
    onCancelarRemoverExpressao() {
      this.dialogRemoverExpressao = false
      this.indexExpressaoRemover = null
    },
    async salvar() {
      await this.$v.$touch()
      if (this.$v.form.$invalid) {
        return
      }

      this.loading = true

      if (this.notificacaoId) {
        await http.put('notificacao', {
          notificacaoId: this.notificacaoId,
          ...this.form,
          expressoes: this.expressoesParaSalvar(),
          horarioExecutarNotificacao: this.getHorarioRange(),
          cargos: this.form.notificacaoCargos.map((e) => e.id),
          botaoAcaoEquipamento: this.botoesDeAcionamento.map((e) => e.id),
        })

        await this.getNotificationData()
      } else {
        const id = await http.post('notificacao', {
          ...this.form,
          ...this.getHorarioRange(),
          expressoes: this.expressoesParaSalvar(),
          localId: this.localId,
          horarioExecutarNotificacao: this.getHorarioRange(),
          cargos: this.form.notificacaoCargos.map((e) => e.id),
          botaoAcaoEquipamento: this.botoesDeAcionamento.map((e) => e.id),
        })

        this.loading = false

        await this.$router.push({
          name: 'NotificacaoIndex',
          params: {
            localId: this.localId,
            notificacaoId: id,
          },
        })
      }
    },
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty,
        }
      }
    },
    getHorarioRange() {
      if (!this.horarioExecutarNotificacoes) {
        return null
      }

      return {
        inicio: this.form.inicio,
        fim: this.form.fim,
      }
    },
    validaSeDiaExecutaAcao(index) {
      return this.form.diasParaExecutarNotificacao.includes(index)
    },
    alternaDia(index) {
      if (this.validaSeDiaExecutaAcao(index)) {
        this.form.diasParaExecutarNotificacao =
          this.form.diasParaExecutarNotificacao.filter((e) => e !== index)
      } else {
        this.form.diasParaExecutarNotificacao = [
          index,
          ...this.form.diasParaExecutarNotificacao,
        ]
      }
    },
    adicionaExpressao() {
      this.form.expressoes = [
        ...this.form.expressoes,
        {
          left: { value: 0, nome: 'Valor', tipo: 1 },
          right: { value: 0, nome: 'Valor', tipo: 1 },
          comparador: '>',
          _clientId: this.novoClientId(),
        },
      ]
    },
    onExcluirExpressao() {
      if (this.indexExpressaoRemover != null) {
        this.form.expressoes.splice(this.indexExpressaoRemover, 1)
      }

      this.indexExpressaoRemover = null
      this.dialogRemoverExpressao = false
    },
  },
}
</script>

<style lang="scss">
@import 'src/assets/vue-material';

.and {
  font-size: 1.5rem;
  color: md-theme(primary);
}
</style>
